
export enum MenuItemType {
	Label = 1,
	Url = 2,
	Page = 4,
}

export enum MenuItemTypeNames {
	"Label" = 1,
	"Url" = 2,
	"Page" = 4,
}
